import { SearchOutlined } from "@ant-design/icons";
import { Button, DatePicker } from "antd"
import { RangePickerProps } from "antd/es/date-picker";
import dayjs from 'dayjs'
const DateRangeSearchInvoice: React.FC<{ isVisible: boolean, datePickerProps: RangePickerProps, onSearchClick: () => void }> = (props) => {
    return props.isVisible ?
        <>
            <DatePicker.RangePicker  {...props.datePickerProps} disabledDate={(date) => date > dayjs()} />
            <Button
                icon={<SearchOutlined />}
                onClick={props.onSearchClick}
            ></Button>
        </>
        : <></>
}
export default DateRangeSearchInvoice;